import { getJwt, HttpError } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

// Shared fetch helper for the feedback endpoints (JWT bearer, JSON in/out, HttpError on non-2xx).
export async function feedbackRequest<T>(path: string, init?: RequestInit): Promise<T> {
    const hasBody = init?.body != null;
    const response = await fetch(`${BASE_URL}/${path}`, {
        ...init,
        headers: {
            'Authorization': `Bearer ${getJwt()}`,
            ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
            ...(init?.headers ?? {}),
        },
    });

    const contentType = response.headers.get('content-type') ?? '';
    const data = contentType.includes('json')
        ? await response.json().catch(() => null)
        : await response.text().catch(() => '');

    if (!response.ok) throw new HttpError(response.status, data);
    return data as T;
}
